/**
 * Tabs for the Bazaarvoice reviews and questions containers.
 *
 * Bazaarvoice renders each container once, measuring it at that moment. Both
 * panels are therefore present and laid out from the start — the inactive one
 * sits off-screen rather than display:none — and a resize event is dispatched
 * when a tab is shown so the widget re-measures against its now-visible box.
 */
(function () {
  function setup(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll("[data-bv-tab]"));
    var panels = Array.prototype.slice.call(root.querySelectorAll("[data-bv-panel]"));
    if (tabs.length < 2) return;

    function select(name, focus) {
      tabs.forEach(function (tab) {
        var on = tab.dataset.bvTab === name;
        tab.setAttribute("aria-selected", on ? "true" : "false");
        tab.tabIndex = on ? 0 : -1;
        if (on && focus) tab.focus();
      });
      panels.forEach(function (panel) {
        panel.classList.toggle("is-active", panel.dataset.bvPanel === name);
      });
      // Let Bazaarvoice re-measure now the panel has a real width.
      window.dispatchEvent(new Event("resize"));
    }

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        select(tab.dataset.bvTab, false);
      });
    });

    // Arrow keys move between tabs, which is what a tablist is expected to do.
    root.querySelector('[role="tablist"]').addEventListener("keydown", function (e) {
      if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
      e.preventDefault();
      var current = tabs.findIndex(function (t) {
        return t.getAttribute("aria-selected") === "true";
      });
      var next = e.key === "ArrowRight" ? current + 1 : current - 1;
      if (next < 0) next = tabs.length - 1;
      if (next >= tabs.length) next = 0;
      select(tabs[next].dataset.bvTab, true);
    });
  }

  function init() {
    document.querySelectorAll("[data-bv-tabs]").forEach(setup);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  // The theme re-renders sections in the editor.
  document.addEventListener("shopify:section:load", init);
})();
